import { render, staticRenderFns } from "./AlertData.vue?vue&type=template&id=888cafc4&scoped=true&"
import script from "./AlertData.vue?vue&type=script&lang=js&"
export * from "./AlertData.vue?vue&type=script&lang=js&"
import style0 from "./AlertData.vue?vue&type=style&index=0&id=888cafc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888cafc4",
  null
  
)

export default component.exports